import React, { useState, useRef, useEffect } from 'react';

interface CustomSelectProps {
  value: string | number;
  options: { label: string; value: string | number }[];
  onChange: (value: any) => void;
  align?: 'left' | 'right';
  className?: string;
}

export const CustomSelect: React.FC<CustomSelectProps> = ({ 
  value, 
  options, 
  onChange, 
  align = 'left',
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = options.find((o:any) => String(o.value) === String(value)) || options[0];

  return (
    <div className={`relative w-full h-8 ${className}`} ref={ref}>
      <button 
        type="button"
        className="w-full h-8 pl-2 pr-1 bg-mp-surface border border-mp-border text-mp-muted font-mono text-xs flex items-center justify-between hover:border-primary transition-colors focus:outline-none group"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{selectedOption?.label}</span>
        <span className="material-symbols-outlined text-[18px] opacity-0 group-hover:opacity-100 transition-opacity">expand_more</span>
      </button>
      
      {isOpen && (
        <div className={`absolute top-full z-50 mt-1 min-w-full bg-mp-surface border border-mp-border py-1 shadow-2xl ${align === 'right' ? 'right-0' : 'left-0'}`}>
          {options.map((option: any) => (
            <button
              key={option.label}
              type="button"
              className={`w-full text-left px-3 py-2 text-xs font-mono transition-colors whitespace-nowrap ${
                String(option.value) === String(value) ? 'bg-primary text-white' : 'text-mp-text hover:bg-mp-surface-hover'
              }`}
              onClick={() => {
                onChange(option.value);
                setIsOpen(false);
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
